// @flow
import React from 'react'
import Dock from 'react-dock'
import { Menu, Button, Icon } from 'semantic-ui-react'
import Scrollchor from 'react-scrollchor'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'

const isMobile = browserCheck.isMobile

export class TopMenu extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
    this.handleMenuClick = this.handleMenuClick.bind(this)
  }

  handleMenuClick(e, { name }) {
    console.log(name)
  }

  componentDidMount() {}

  render() {
    const output = this.props.heldinnenData.map(
      function(person, i) {
        return (
          /*
          <Person
            name={person.Name}
            image={person.Bild}
            format={person.Format}
            function={person.Zeitraum}
            text={person.Text}
            key={'person-' + i}
            index={i}
          />
          */
          <Scrollchor
            to={'#person-' + i}
            animate={{ offset: -15, duration: 600 }}
            className='nav-link'
          >
            <Menu.Item name={person.Name}>{person.Name}</Menu.Item>
          </Scrollchor>
        )
      }.bind(this)
    )

    return (
      <div>
        <Dock
          position={'top'}
          size={1}
          dimMode='none'
          isVisible={this.props.menuOpen}
        >
          <div onClick={this.props.closeMenu} className='top-menu'>
            <Menu className='vertical'>
              {output}
              <Button
                onClick={this.props.closeMenu}
                attched='right'
                className='closer'
              >
                <Icon name='close' />
              </Button>
            </Menu>
          </div>
        </Dock>
      </div>
    )
  }
}
